import { IconGlyph } from '../Icon';

export enum ButtonAppearance {
  WHITE = 'white',
  PRIMARY_GRADIENT = 'primaryGradient',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SECONDARY_BORDERED = 'secondaryBordered',
  LINK = 'link',
  TEXT = 'text',
  PRIMARY_BORDERED_GRADIENT = 'primaryBorderedGradient',
  WHITE_BORDERED_GRADIENT = 'whiteBorderedGradient',
}

export enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum IconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export interface IButtonIcon {
  position: IconPosition;
  glyph: IconGlyph;
}
